import { createTrpcClients } from '@markku/utils'
import type { AppRouter } from '@markku/backend/trpc/router'

const handleAuthError = async () => {
  const authStore = await import('../store/useAuthStore').then(
    (m) => m.useAuthStore,
  )
  authStore.getState().logout()

  if (window.location.pathname !== '/') {
    const returnUrl = encodeURIComponent(window.location.pathname)
    window.location.href = `/?redirect=${returnUrl}`
  }
}

export const { trpc, trpcClient, enhancedFetch } = createTrpcClients<AppRouter>(
  {
    onAuthError: handleAuthError,
  },
)
